import { Container } from "../components/container";

export function About() {
  return (
    <Container
      className="min-h-dvh flex flex-col !mx-auto !max-w-[770px] pt-[195px]"
      id="about"
    >
      <p className="mt-[20px] mb-[50px] text-center">
        <strong>East landscape:s</strong> arbete grundar sig på tre pelare:
      </p>
      <AboutColumn index={1} title="Hållbar Landskapsarkitektur">
        East landscape står för att den riktigt hållbara landskapsarkitekturen
        skapas genom en genomtänkt och grundlig höjdsättning i det gestaltande
        arbetet. Vikten av god dagvatten- och skyfallshantering och att
        synliggöra betydelsen av att tillhandahålla vattnet som kommer marken
        till godo. På sätt kan vi skapa platser som klarar kraftig nederbörd
        likväl som långvarig torka. Vi behöver öka förståelsen i branschen för
        vattnets väg och se vattnet för den resurs som det faktiskt är.
      </AboutColumn>
      <AboutColumn index={2} title="Tillgänglig & jämställd utemiljö">
        East landscape står för att alla har lika rätt – att det för alla
        människor oavsett funktionsnedsättning eller begränsningar alltid ska
        finnas en plats i vårt samhälle och i vår utemiljö. Det kräver av oss
        landskapsarkitekter att se bredare, förstå mer och vidga våra vyer av
        vad en god utemiljö är för olika personer. Ett särskilt stort fokus bör
        läggas på att skapa lekmiljöer åt alla barn. Inget barn ska lämnas åt
        sidan – inget barn är av mindre värde och vikt – vi måste se till alla
        barns behov.
      </AboutColumn>
      <AboutColumn index={3} title="Lyft de gröna värdena i staden">
        East landscape står för att lyfta de gröna värdena i staden och för att
        göra våra städer grönare i grunden. Genom att skapa grönare städer kan
        vi på ett fullgott sätt ta till vara på vårt vatten och skapa städer som
        står starka mot klimtförändringar. Grönska som är varierad, plats- och
        årstidsanpassad förgyller våra liv – lyfter var och en av våra säsonger
        och ger oss alltid något att se fram emot. Det tilltalar alla våra
        sinnen – oavsett bakgrund, ålder eller funktionsnivå.
      </AboutColumn>
    </Container>
  );
}

export function AboutColumn({
  index,
  title,
  children,
}: {
  index: number;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-wrap lg:flex-nowrap mb-[90px]">
      <h1 className="lg:min-w-[20%] grow lg:flex-none font-[agency-fb] text-[180px] text-center lg:text-left">
        {index}.
      </h1>
      <div>
        <h2 className="mb-[10px] uppercase font-[agency-fb] text-[44px] text-center lg:text-left">
          {title}
        </h2>
        <div className="lg:max-w-[90%] leading-[1.3] text-center lg:text-left">
          {children}
        </div>
      </div>
    </div>
  );
}
